import type { DateOnlyFormat, DateRangeFormat, FormatDateOptions, NullableDateInput } from '@localization/formatters/dateFormatter';
import type { EventLocaleFormatter } from '@localization/hooks/useEventLocaleFormatter';
import type { EventDateDisplayContent } from './eventDateDisplay.types';

type DateFormatters = Pick<EventLocaleFormatter, 'formatDate' | 'formatEventDateRange'>;

// Multi-day event date (PRNT-4321). When a range is saved, render the range (start = the event date,
// end = content.eventEndDate) or the verbatim custom text; otherwise fall back to the single formatted
// date. This util is flag-independent — it formats whatever saved data it's given; each caller decides
// whether to gate rendering behind the multi-day flag. Shared by the welcome page (EventDetailsGuest),
// the registry header, and the contact collector so the surfaces stay in sync.
export const resolveEventDateDisplay = (
  content: EventDateDisplayContent,
  startTimestamp: NullableDateInput,
  options: FormatDateOptions,
  { formatDate, formatEventDateRange }: DateFormatters,
): string | undefined => {
  const dateFormat = (content.dateFormat ?? 'weekday, dd MMMM yyyy') as DateOnlyFormat;
  const isRangeMode = content.dateDisplayType === 'dateRange';
  const customText = content.customText?.trim();
  return isRangeMode && content.dateRangeFormat === 'custom'
    ? customText || formatDate(startTimestamp, dateFormat, options)
    : isRangeMode && content.eventEndDate
      ? formatEventDateRange(startTimestamp, content.eventEndDate, (content.dateRangeFormat as DateRangeFormat) ?? 'weekday, dd MMMM yyyy', options)
      : formatDate(startTimestamp, dateFormat, options);
};
